import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AllSchoolSubjectiveExamPricing = () => {

  const navigate = useNavigate();

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const [allSEPricing, setAllSEPricing] = useState([]);

  const [schoolClassName, setSchoolClassName] = useState([]);

  const [schoolClassNameId, setSchoolClassNameId] = useState("");

  const [subjects, setSubjects] = useState([]);

  const [subjectId, setSubjectId] = useState("");

  const [loading, setLoading] = useState(false);



  /* ================= FETCH CLASSES ================= */

  useEffect(() => {

    axios.get(`${API_BASE_URL}/classes`)
      .then(resp => {

        setSchoolClassName(resp.data.data);

      })
      .catch(console.log);

  }, []);



  /* ================= FETCH SUBJECTS ================= */

  useEffect(() => {

    if (!schoolClassNameId) {

      setSubjects([]);

      setSubjectId("");

      return;

    }

    axios.get(
      `${API_BASE_URL}/subjects?reference=${schoolClassNameId}`
    )
    .then(res => {

      setSubjects(res.data.data);

    })
    .catch(console.log);

  }, [schoolClassNameId]);



  /* ================= SEARCH ================= */

  const handleSearch = async (e) => {

    e.preventDefault();

    if (!schoolClassNameId || !subjectId) {

      alert("Please select class and subject");

      return;

    }

    try {

      setLoading(true);

      const result = await axios.get(
        `${API_BASE_URL}/pricing/subjective-exam?classId=${schoolClassNameId}&subjectId=${subjectId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        }
      );

      setAllSEPricing(result.data.data);

    }
    catch (error) {

      console.log(error);

    }
    finally {

      setLoading(false);

    }

  };



  /* ================= NAVIGATION ================= */

  const handleAddNewSSExamPricing = () => {

    navigate("/subjective-exam-pricing/add-school-subjective-exam-pricing");

  };



  const handleViewAllSSExamPricing = () => {

    navigate("/subjective-exam-pricing/all-school-subjective-exam-pricing");

  };



  const handleEdit = (id) => {

    navigate(
      `/subjective-exam-pricing/edit-school-subjective-exam-pricing/${id}`
    );

  };



  /* ================= UI ================= */

  return (

    <div id="classes-inner-wrapper">


      {/* HEADER */}

      <div className="classes-header-div">

        <h5>School Subjective Exam Pricing</h5>

        <div className="classes-header-btns">

          <button
            className="add-class-btn"
            onClick={handleAddNewSSExamPricing}
          >
            + Add Price
          </button>

          <button
            className="all-classes-btn"
            onClick={handleViewAllSSExamPricing}
          >
            All Price
          </button>

        </div>

      </div>



      {/* SEARCH FORM */}

      <form onSubmit={handleSearch} className="note-detail-form">


        {/* CLASS SELECT */}

        <div className="input-group">

          <label className="label">
            Class Name
          </label>

          <select
            className="select-dropdown"
            value={schoolClassNameId}
            onChange={(e) =>
              setSchoolClassNameId(e.target.value)
            }
            required
          >

            <option value="">
              Select Class
            </option>

            {schoolClassName.map(classes => (

              <option
                key={classes._id}
                value={classes._id}
              >
                {classes.className}
              </option>

            ))}

          </select>

        </div>



        {/* SUBJECT SELECT */}

        <div className="input-group">

          <label className="label">
            Subject Name
          </label>

          <select
            className="select-dropdown"
            value={subjectId}
            onChange={(e) =>
              setSubjectId(e.target.value)
            }
            required
          >

            <option value="">
              Select Subject
            </option>

            {subjects.map(subject => (

              <option
                key={subject._id}
                value={subject._id}
              >
                {subject.subjectName}
              </option>

            ))}

          </select>

        </div>



        <button
          className="btn-save"
          type="submit"
        >
          {loading ? "Searching..." : "Search"}
        </button>

      </form>



      {/* TABLE */}

      <div className="classes-table-container">

        <h5>Pricing List</h5>

        <table className="classes-table">

          <thead>

            <tr>

              <th>S.No</th>

              <th>Class</th>

              <th>Subject</th>

              <th>Price</th>

              <th>Action</th>

            </tr>

          </thead>


          <tbody>

            {allSEPricing.length === 0 ? (

              <tr>

                <td colSpan="5">
                  No pricing found
                </td>

              </tr>

            ) : (

              allSEPricing.map((data, idx) => (

                <tr key={data._id}>

                  <td>
                    {idx + 1}
                  </td>

                  <td>
                    {data?.classId?.className}
                  </td>

                  <td>
                    {data?.subjectId?.subjectName}
                  </td>

                  <td>
                    ₹ {data?.price}
                  </td>

                  <td className="table-action-icons">

                    <i
                      className="fa-solid fa-file-pen"
                      onClick={() =>
                        handleEdit(data._id)
                      }
                      style={{
                        cursor: "pointer"
                      }}
                    ></i>

                  </td>

                </tr>

              ))

            )}

          </tbody>

        </table>

      </div>

    </div>

  );

};

export default AllSchoolSubjectiveExamPricing;
